/*
  https://stackblitz.com/edit/mat-dialog-example


    const dialogRef = this.dialog.open(AlertDialog, {
      data:{
        sound: Sound.ErrorBeep,
        message: 'Hello World',
        icon: 'warning',
        buttonText: 'OK'
      },
    });
*/
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AudioService, Sound } from './../../services/audio.service';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html'
})
export class AlertDialog {
  message: string = "An unspecified error has occurred";
  icon: string = "";
  buttonText = "Cancel";

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: {
      sound?: Sound,
      message: string,
      icon: string,
      buttonText: string
    },
    private dialogRef: MatDialogRef<AlertDialog>,
    private audio: AudioService,
  ) {
    if (data) {
      this.message = data.message || this.message;
      this.buttonText = data.buttonText || this.buttonText;
      if (data.icon) this.icon = data.icon;
      if (data.sound) this.audio.play(data.sound);
    }
  }

  onCloseClick(): void {
    this.dialogRef.close(true);
  }

}